import React from 'react';
import GreenLeafApi from '../utils/GreenLeafApi';
import PropTypes from 'prop-types';
import {Button, ListGroup, ListGroupItem, Modal} from 'react-bootstrap';
import './SelectSubsectionModal.css';
import ProgressBarItem from './ProgressBar';

class SelectSubsectionModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      assessmentDetail: null,
      subsections: [],
      coachSubScores: [],
      groupSubScores: [],
      selectedSubs: [],
      saved: false,
      error: null
    };

    this.fetchSubsections = this.fetchSubsections.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.onExit = this.onExit.bind(this);
  }

  async onEnter() {
    try {
      await this.fetchSubsections();
    } catch (e) {
      this.setState({ error: e.errors });
    }
  }

  async fetchSubsections() {
    const assessment = await GreenLeafApi.Assessment.getSubsToSelect({assessment_id: this.props.assessDetail.assessment_id});

    let coachSubScores,
      groupSubScores,
      subs = [];
    if (this.props.assessDetail.team_assessment_id) {
      coachSubScores = (await GreenLeafApi.TeamAssessment.getSubScores({team_assessment_id: this.props.assessDetail.team_assessment_id}));

      for (let i = 0; i < coachSubScores.data.scores.length; i++) {
        let sub = assessment.data[0].subsections.find((sub) => sub.id === coachSubScores.data.scores[i].subsection_id);
        subs.push(sub);
      }
    } else {
      groupSubScores = (await GreenLeafApi.GroupTeamAssessment.getSubScores({group_team_assessment_id: this.props.assessDetail.group_team_assessment_id}));
      for (let i = 0; i < groupSubScores.data.scores.length; i++) {
        let sub = assessment.data[0].subsections.find((sub) => sub.id === groupSubScores.data.scores[i].subsection_id);
        subs.push(sub);
      }
    }

    this.setState({ assessmentDetail: this.props.assessDetail,
      coachSubScores: coachSubScores ? coachSubScores.data.scores: null,
      groupSubScores: groupSubScores ? groupSubScores.data.scores: null,
      subsections: subs,
      loading: false});

  }

  toggleSub(subId) {
    this.setState((state) => {
      let s = state.subsections.find((sub) => sub.id === subId);
      s.selected = !s.selected;

      if (s.selected && !state.selectedSubs.find((sub) => sub === s.id)) {
        state.selectedSubs.push(s.id);
      } else if (!s.selected) {
        state.selectedSubs = state.selectedSubs.filter((sub) => sub !== s.id);
      }

      return state;
    });
  };

  async submitSelectedSubs(selectAll) {
    if (this.state.assessmentDetail.team_assessment_id) {
      let totalSubs = this.state.subsections.map((sub) => sub.id);
      if (selectAll) {
        let totalSubs = [];
        for (let i = 0; i < this.state.subsections.length; i++) {
          totalSubs.push(this.state.subsections[i].id);
        }
      }

      try {
        let teamAssessment = await GreenLeafApi.TeamAssessment.create({ team_id: this.state.assessmentDetail.team_id, assessment_id: this.state.assessmentDetail.assessment_id,
          coach_id: this.state.assessmentDetail.coach_id, company_id: this.props.company_id,
          subsection_ids: selectAll ? totalSubs : this.state.selectedSubs});

        if (teamAssessment) {
          this.setState({saved: true});
          this.props.handleSubmitSubs(teamAssessment);
        } else {
          this.setState({error: teamAssessment.errors});
        }
      } catch (e) {
        this.setState({error: e.errors});
      }

    } else {
      let totalSubs = this.state.subsections.map((sub) => sub.id);
      if (selectAll) {
        totalSubs = [];
        for (let i = 0; i < this.state.subsections.length; i++) {
          totalSubs.push(this.state.subsections[i].id);
        }
      }

      this.setState({saved: true});

      this.props.handleSubmitSubs(null, selectAll ? totalSubs : this.state.selectedSubs);
    }
  };

  onExit() {
    this.setState({
      loading: true,
      assessmentDetail: null,
      subsections: [],
      selectedSubs: []
    });
  }

  render() {
    let subsectionList = this.state.subsections.map((s, index) => {
      return s ? (
        <div key={index} className='sub-list'>
          <ListGroup data-cy='subsection-list'>
            <ListGroupItem
              data-cy={'subsection-item-' + index}
              key={s.id}
              onClick={() => { this.toggleSub(s.id); }}
              active={s.selected}
            >
              {s.name}
              <div style={{width: '150px', float: 'right'}}>
                { this.state.coachSubScores ?
                  <ProgressBarItem
                    placement={'left'}
                    score={this.state.coachSubScores[index].score}
                    width={'150px'} /> :
                  <ProgressBarItem
                    placement={'left'}
                    score={this.state.groupSubScores[index].score}
                    width={'150px'} />
                }
              </div>
            </ListGroupItem>
          </ListGroup>
        </div>
      ) : null;
    });

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.handleClose}
        onEnter={this.onEnter}
        onExit={this.onExit}>
        <Modal.Header closebutton="true">
          <Modal.Title>Select Subsections to Re-Assess </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ListGroup componentClass="div">
            {
              !this.state.loading && subsectionList
            }
          </ListGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => { this.submitSelectedSubs(true); }}>Select All</Button>
          <Button disabled={this.state.selectedSubs.length <=0} data-cy='submit-subs-to-assess' onClick={() =>  { this.submitSelectedSubs(false);}}>Ok</Button>
        </Modal.Footer>
      </Modal>
    );
  };
}

SelectSubsectionModal.propTypes = {
  assessDetail: PropTypes.object,
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  handleSubmitSubs: PropTypes.func
};

export default SelectSubsectionModal;


// WEBPACK FOOTER //
// ./src/components/teams/SelectSubsectionModal.js